import React, { useEffect, useState } from "react";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import { Spin } from "antd";
import Bridge from "../../../constants/Bridge";

const ViewLogsDetails = () => {
  // state list
  const [emailBody, setEmailBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("");
  // on load component function
  useEffect(() => {
    getEmailBody();
    setPage(localStorage.getItem("page"));
  }, [0]);
  // get email body
  const getEmailBody = () => {
    setLoading(true);
    let reminder_email_logs_id = localStorage.getItem("reminder_email_logs_id");
    let url = `?reminder_email_logs_id=${reminder_email_logs_id}`;
    Bridge.participants
      .getEmailBody(url)
      .then(function (response) {
        if (response.data.status == "1") {
          setEmailBody(response.data.email_body);
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };
  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10" style={{ marginLeft: "auto" }}>
          <br />
          <br />
          <a href={`/${page}`} className="go-back">
            <i className="fas fa-chevron-left"></i>
          </a>
          <div
            className="wrapper clearfix records-wrapper view-report-section"
            style={{ margin: 0, boxShadow: "none" }}
          >
            <h3
              className="log-heading"
              style={{ marginTop: 20, fontStyle: "inherit", marginBottom: 22 }}
            >
              Email Body
            </h3>
            <div className="multisteps-form reports-page">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto">
                  <div className="row view-report-table">
                    <div className="col-12 col-lg-12">
                      <Spin spinning={loading}>
                        <iframe
                          srcdoc={emailBody}
                          width="100%"
                          height="700"
                        ></iframe>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewLogsDetails;
